import React from 'react';
import CircularProgress from '@mui/material/CircularProgress'

const Spinner = () => {
  return (
    <div style={{ display: 'flex',height: '100vh',}}>
      <CircularProgress style={{
      display: 'block',
      margin: 'auto',
      width: '180px !important',
      height: 'auto !important',
    }}  />
    </div>
  );
};

export default Spinner;
